import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import { currentDateTime, wtFormatDate } from 'src/helpers/commons/moment';
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtFormatMoney } from 'src/helpers/commons/utils';

const user = wtGetFromLocalStorage('authUser')

const buildPreparedPdfData = (data = []) => {
    const MAX_NOTE_EXPANSION_LEVEL = 3;
    let noteCounter = 0;
    const summaryRows = [];
    const notesRows = [];

    const walkNotes = (row, notePrefix, depth) => {
        if (!row || row.type !== 1) {
            return;
        }

        notesRows.push({
            account_description: `${notePrefix}  ${String(row.name || '').trim()}`,
            current_year_balance: "",
            last_year_balance: "",
            note: "",
            rowToBold: true,
            rowToUnderline: false,
            type: row.type,
        });

        const children = Array.isArray(row.children) ? row.children : [];

        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            const childNote = `${notePrefix}.${i + 1}`;

            notesRows.push({
                account_description: `${"        ".repeat(depth + 1)}${child.name || ''}`,
                current_year_balance: child.current_year_balance,
                last_year_balance: child.last_year_balance,
                note: childNote,
                rowToBold: false,
                rowToUnderline: false,
                type: child.type,
            });

            if (
                Array.isArray(child.children) &&
                child.children.length > 0 &&
                child.type === 1 &&
                Number(child.level) <= MAX_NOTE_EXPANSION_LEVEL
            ) {
                walkNotes(child, childNote, depth + 1);
            }
        }

        if (children.length > 0) {
            notesRows.push({
                account_description: "",
                current_year_balance: row.current_year_balance,
                last_year_balance: row.last_year_balance,
                note: "",
                rowToBold: true,
                rowToUnderline: true,
                type: children[children.length - 1].type,
            });
        }
    };

    for (let i = 0; i < data.length; i++) {
        const row = data[i];
        const note = row.type === 1 ? ++noteCounter : "";

        summaryRows.push({
            account_description: row.name,
            current_year_balance: row.current_year_balance,
            last_year_balance: row.last_year_balance,
            note,
            type: row.type,
        });

        if (row.type === 1) {
            walkNotes(row, String(note), 0);
        }
    }

    return { summaryRows, notesRows };
};

const Pdf = async (profitAndLossData, asOf, lastYearLastDate) => {

    const generatePdf = (profitAndLossData, asOf, lastYearLastDate) => {

        if (!profitAndLossData) {
            lzNotifyErrorMessageFromResult("No Data found!");
            return;
        }

        var doc = new jsPDF();
        var totalPagesExp = '{total_pages_count_string}';
        const preparedPdfData = buildPreparedPdfData(profitAndLossData);

        const logo = 'assets/wil-icon.png';

        const header = () => {
            var pageSize = doc.internal.pageSize;
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

            doc.setFontSize(11);
            doc.setTextColor('#3c4b64');
            doc.setFont('Helvetica', 'bold');
            doc.addImage(logo, 'PNG', 5, 4, 25, 25);
            doc.line(32, 6, 32, 25);

            doc.text('WAH', 35, 10, { align: 'left' });
            doc.text('INDUSTRIES', 35, 15);
            doc.text('LIMITED', 35, 20);
            doc.setFontSize(9);
            doc.text('www.wahindustries.com', 35, 25);
            doc.setFontSize(11);
            doc.text("STATEMENT OF PROFIT AND LOSS", pageWidth - 85, 15, { align: 'left' });
            doc.text("FOR THE YEAR ENDED " + wtFormatDate(asOf, "MMMM D, Y"), pageWidth - 85, 22, { align: 'left' });

            doc.line(10, 30, pageWidth - 10, 30);
        };


        const headerNotes = () => {
            var pageSize = doc.internal.pageSize;
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();

            doc.setFontSize(11);
            doc.setTextColor('#3c4b64');
            doc.setFont('Helvetica', 'bold');
            doc.addImage(logo, 'PNG', 5, 4, 25, 25);
            doc.line(32, 6, 32, 25);

            doc.text('WAH', 35, 10, { align: 'left' });
            doc.text('INDUSTRIES', 35, 15);
            doc.text('LIMITED', 35, 20);
            doc.setFontSize(9);
            doc.text('www.wahindustries.com', 35, 25);
            doc.setFontSize(11);
            doc.text("NOTES TO THE FINANCIAL STATEMENTS", pageWidth - 88, 15, { align: 'left' });
            doc.text("FOR THE YEAR ENDED " + wtFormatDate(asOf, "MMMM D, Y"), pageWidth - 88, 22, { align: 'left' });

            doc.line(10, 30, pageWidth - 10, 30);
        };

        const footer = () => {
            let pageNo = doc.internal.getNumberOfPages();
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

            doc.setFontSize(10)
            doc.text(
                "This report is printed through ERP at ",
                60,
                pageHeight - 15
            );


            doc.setTextColor('#0202f7')
            doc.setFont('Helvetica', 'bold')

            doc.text(
                currentDateTime(),
                124,
                pageHeight - 15
            );



            ///////////////////////////////////////Second part of footer

            var str = 'Page ' + pageNo;
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp;
            }

            doc.setTextColor('black')
            doc.setFontSize(9)
            const lineHeight = 286
            const lineWidth = 182
            const lineX = 14
            const lineY = lineHeight
            doc.line(lineX, lineY, lineX + lineWidth, lineY)
            doc.text(str, 230, 290, { align: 'right' })
            doc.text(`Printed By `, 20, 290, { align: 'left' })
            doc.setTextColor('blue')
            doc.text(`${user ? user.name : ''}`, 37, 290, { align: 'left' })

        };

        const profitAndLossFirstPage = () => {
            doc.autoTable({
                head: headRows(asOf, lastYearLastDate),
                body: bodyRows(preparedPdfData.summaryRows),
                theme: "plain",
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [60, 75, 100],
                    fontSize: 10,
                },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 90, minCellHeight: 6, font: "helvetica", fontSize: 9 },  // Account Description
                    1: { halign: 'center', cellWidth: 15, minCellHeight: 6, font: "helvetica", fontStyle: 'bold', fontSize: 9 }, // Note
                    2: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Current Year
                    3: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Last Year
                },
                margin: { top: 40, bottom: 15, left: 10 },
                didDrawPage: function () {
                    header();
                    footer();
                },
                willDrawCell: function (data) {

                    if (data.row.section === 'head' && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineY = cell.y + cell.height;

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(1); // Set line width
                        doc.line(lineX, lineY, lineX + lineWidth - 2, lineY); // Draw the line
                    }

                    if (data.row.section === 'body' && data.row.raw[4].content === 2 && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineYTop = cell.y; // Top position of the cell

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(0.2); // Set line width

                        // Draw the top border
                        doc.line(lineX, lineYTop, lineX + lineWidth - 2, lineYTop);
                    }
                },
                didParseCell: function (data) {
                    if (data.section === 'body' && data.row.raw[4].content === 2) {
                        data.cell.styles.fontSize = 10;
                        data.cell.styles.fontStyle = 'bold';
                    }
                    if (data.section === 'head') {
                        data.cell.styles.fontStyle = 'bold';
                    }
                },
            });
        };

        const profitAndLossNotesPages = () => {
            // Add a new page for the second table
            doc.addPage();

            doc.autoTable({
                head: headRows(asOf, lastYearLastDate),
                body: bodyRowsNotes(preparedPdfData.notesRows),
                theme: "plain",
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [60, 75, 100],
                    fontSize: 10,
                },
                columnStyles: {
                    0: { halign: 'left', cellWidth: 90, minCellHeight: 6, font: "helvetica", fontSize: 9 },  // Account Description
                    1: { halign: 'center', cellWidth: 18, minCellHeight: 6, font: "helvetica", fontStyle: 'bold', fontSize: 9 }, // Note
                    2: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Current Year
                    3: { halign: 'right', cellWidth: 40, minCellHeight: 6, font: "helvetica", fontSize: 9 }, // As Of Last Year
                },
                margin: { top: 40, bottom: 30, left: 10 },
                didDrawPage: function () {
                    headerNotes();
                    footer();
                },
                willDrawCell: function (data) {

                    if (data.row.section === 'head' && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineY = cell.y + cell.height;

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(1); // Set line width
                        doc.line(lineX, lineY, lineX + lineWidth - 2, lineY); // Draw the line
                    }

                    if (data.row.section === 'body' && data.row.raw[5].content === true && data.column.index > 1) {
                        const { doc, cell } = data;
                        const lineWidth = cell.width;
                        const lineX = cell.x + 2;
                        const lineYTop = cell.y; // Top position of the cell

                        doc.setDrawColor(0, 0, 0); // Black color
                        doc.setLineWidth(0.5); // Set line width

                        // Draw the top border
                        doc.line(lineX, lineYTop, lineX + lineWidth - 2, lineYTop);
                        doc.line(lineX, lineYTop + 6, lineX + lineWidth - 2, lineYTop + 6);
                    }
                },
                didParseCell: function (data) {
                    if (data.section === 'body' && data.row.raw[4].content === 2) {
                        data.cell.styles.fontSize = 10.5;
                        data.cell.styles.fontStyle = 'bold';
                    }
                    if (data.section === 'head') {
                        data.cell.styles.fontStyle = 'bold';
                    }
                },
            });
        };

        profitAndLossFirstPage();
        profitAndLossNotesPages();

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }

        const pdfBlob = doc.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    };

    const headRows = (asOf, lastYearLastDate) => {
        return [
            [
                { content: "", styles: { halign: 'center', cellWidth: 90, } },
                { content: "Note ", styles: { halign: 'center', valign: "bottom", cellWidth: 15, } },
                { content: wtFormatDate(asOf, "YYYY") + "\n(Rupees)", styles: { halign: 'center', cellWidth: 40, } },
                { content: wtFormatDate(lastYearLastDate, "YYYY") + "\n(Rupees)", styles: { halign: 'center', cellWidth: 40, } },
            ]
        ];
    };

    const bodyRows = (rows) => {
        return rows.map(row => [
            { content: row.account_description, styles: { halign: 'left' } },
            { content: row.note, styles: { halign: 'center' } },
            { content: wtFormatMoney(row.current_year_balance, "", true, 2), styles: { halign: 'right' } },
            { content: wtFormatMoney(row.last_year_balance, "", true, 2), styles: { halign: 'right' } },
            { content: row.type, styles: { display: 'none' } }
        ]);
    };

    const bodyRowsNotes = (rows) => {
        return rows.map(row => [
            { content: row.account_description, styles: { halign: 'left', fontStyle: (row.rowToBold) ? "bold" : "normal", fontSize: (row.rowToBold) ? 10.5 : 9 } },
            { content: row.note, styles: { halign: 'center', fontStyle: "bold", fontSize: 10 } },
            { content: row.current_year_balance !== '' ? wtFormatMoney(row.current_year_balance, "", true, 2) : "", styles: { halign: 'right', fontStyle: (row.rowToBold) ? "bold" : "normal" } },
            { content: row.last_year_balance !== '' ? wtFormatMoney(row.last_year_balance, "", true, 2) : "", styles: { halign: 'right', fontStyle: (row.rowToBold) ? "bold" : "normal" } },
            { content: row.type, styles: { display: 'none' } },
            { content: row.rowToUnderline, styles: { display: 'none' } }
        ]);
    };

    generatePdf(profitAndLossData, asOf, lastYearLastDate);

};


export default Pdf;
